import { OperationContext, OperationSpec } from './OperationContext'
import { RunnableOperation } from './RunnableOperation'

export class RunnablePasswordUpdate extends RunnableOperation {
  constructor(userOpSpec: OperationSpec) {
    super(userOpSpec)
  }

  async defineRequest(context: OperationContext): Promise<void> {
    super.defineRequest(context)
    if (this.aborted) {
      throw new Error('Operation aborted')
    }

    context.declareRequestSpec = {
      operationType: 'password.update',
      pathName: this.userOpSpec.to || '',
      encriptionIV: this.userOpSpec.iv,
      encriptionDEK: this.userOpSpec.enc_dek,
      contentMD5: this.userOpSpec.md5,
      contentLength: this.userOpSpec.encrypted_content?.length || 0,
      content: {
        info: this.userOpSpec.info,
        encrypted_content: this.userOpSpec.encrypted_content,
      },
    }
  }

  async execute(context: OperationContext): Promise<void> {
    if (this.aborted) {
      throw new Error('Operazione interrotta')
    }

    // Implementa la logica di esecuzione qui
  }

  abort(): void {
    this.aborted = true
  }
}
